(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-center-stage13"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-stage14-newsletter]').forEach((form) => {
    const result = form.querySelector('[data-stage14-form-result]');
    if (result) {
      requestAnimationFrame(() => result.focus({ preventScroll: false }));
    }
    form.addEventListener('submit', () => {
      const button = form.querySelector('button[type="submit"]');
      const live = form.querySelector('[data-stage14-form-live]');
      if (!button || button.disabled) return;
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      button.textContent = button.dataset.loadingLabel || button.dataset.defaultLabel;
      if (live) live.textContent = button.dataset.loadingLabel || '';
    }, { once: true });
  });

  } catch(e) { console.error(e); }
})();
})();
